!function () {
	'use strict';
	$(() => {
		const CustomSelectionAdapter = $.fn.select2.amd.require('select2/selection/customSelectionAdapter');

		$.fn.Select2UpdatePlaceholder = function (newPlaceholder) {
			const $select2 = $(this).data('select2');
			$select2.selection.placeholder.text = newPlaceholder;
			return $select2.$container.find('.select2-selection__placeholder').text(newPlaceholder);
		};

		$('.Select').each(function () {
			const select = this;
			const {
				tagsContainer = null,
				placeholderDefault = '',
				placeholderSelected = ''
			} = this.dataset;
			const hasMultiple = select.getAttribute('multiple');
			const selectArgs = {
				placeholder: placeholderDefault,
				width: '100%',
			};

			const selectMultipleArgs = hasMultiple ? {
				selectionAdapter: CustomSelectionAdapter,
				selectionContainer: $(tagsContainer),
			} : {};

			const fieldset = select.closest('fieldset');
			const clearButton = fieldset.querySelector('button.clear-select');
			if (clearButton) {
				if (select.value) clearButton.classList.add('active');
				clearButton.addEventListener('click', () => {
					$(select).val('').trigger('change');
					$(select).trigger('select2:unselect');
				});
			}

			$(select).select2({
				...selectArgs,
				...selectMultipleArgs,
			})
			.on('select2:select select2:unselect', function (e) {
				const selectElement = e.currentTarget;
				const data = $(selectElement).select2('data');
				if (clearButton) {
					clearButton.classList.toggle('active', data.length && data[0]?.id);
				}
				if (hasMultiple && document.querySelector(tagsContainer)) {
					$(selectElement).Select2UpdatePlaceholder(
						data.length
							? placeholderSelected.replace('{count}', data.length)
							: placeholderDefault
					);
					$(selectElement).trigger('change');
				}
			});
		});
	});
}();
